class EnumService {
  getYesNo(t) {
    return [
      { label: t('common.yes'), value: true },
      { label: t('common.no'), value: false },
    ];
  }
  getOkNok(t) {
    return [
      { label: t('common.ok'), value: true },
      { label: t('common.nok'), value: false },
    ];
  }

  getTranslatedEnum(t, enumType, translationPrefix: string, translateValue = false) {
    return Object.keys(enumType).map((value) => {
      const objectValue = translateValue ? t(`${translationPrefix}.${value}`) : enumType[value];
      return { label: t(`${translationPrefix}.${value}`), value: objectValue };
    });
  }
}

const enumService = new EnumService();
export default enumService;
